import { KeyFilterChartTradeDataUnitBy } from "src/utils/constants/enum";

export class TradeDataUnitByFilter {
  value: KeyFilterChartTradeDataUnitBy = KeyFilterChartTradeDataUnitBy.value_usd

  private readonly stacks = [
    KeyFilterChartTradeDataUnitBy.bol,
    KeyFilterChartTradeDataUnitBy.weight,
    KeyFilterChartTradeDataUnitBy.quantity,
  ];

  public readonly passed: KeyFilterChartTradeDataUnitBy[] = [
    this.value
  ];

  constructor() {

  }

  public next() {
    if (this.stacks.length > 0) {
      this.value = this.stacks.shift() as KeyFilterChartTradeDataUnitBy
      this.passed.push(this.value)
      return this.value
    }
    return this.value
  }

  public isUserClickBack(currentFilter: KeyFilterChartTradeDataUnitBy) {
    return this.passed.includes(currentFilter) && currentFilter !== this.value;
  }
}